import { useTranslation } from "react-i18next"

import { StatusBadge } from "@/components/status-badge"
import { contractStatusTone } from "@/components/status-tone"

export function ContractStatusBadge({ status }: { status?: string | null }) {
  const { t } = useTranslation("contracts")
  if (!status) return null
  const label = t(`status.${status}`, { defaultValue: status })
  return <StatusBadge tone={contractStatusTone(status)}>{label}</StatusBadge>
}
